import { clearTokens } from './authTokens';
import { clearUserSession } from './authSession';
import { clearRegularExamStartRecords } from './regularExamStartRecord';

/** Path prefix for deploy (same rules as BrowserRouter `basename`). */
function getDeployPathPrefix(): string {
  const raw = process.env.REACT_APP_BASE_PATH ?? '/';
  return raw === '/' ? '' : raw.replace(/\/$/, '');
}

/**
 * Absolute path for static files from `/public` (e.g. logos).
 * In development, CRA serves `public/` at the server root, so this is always `/file…`
 * even when `REACT_APP_BASE_PATH` is set (subpath router only).
 * In production builds, prefix follows `REACT_APP_BASE_PATH` so prod (root) and test
 * (subpath) match how the app is deployed — unlike `process.env.PUBLIC_URL`, which
 * follows `package.json` `homepage` for every production build.
 */
export function getPublicFolderAssetUrl(filename: string): string {
  const name = filename.replace(/^\//, '');
  if (process.env.NODE_ENV !== 'production') {
    return `/${name}`;
  }
  const base = getDeployPathPrefix();
  return base ? `${base}/${name}` : `/${name}`;
}

/**
 * Login path including optional REACT_APP_BASE_PATH (must match BrowserRouter basename).
 */
export function getLoginPathname(query?: URLSearchParams): string {
  const base = getDeployPathPrefix();
  const q = query && query.toString() ? `?${query.toString()}` : '';
  return `${base}/login${q}`;
}

/**
 * Clears auth and sends the user to login (full navigation so React state resets).
 */
export function clearAuthAndRedirectToLogin(reason: string = 'session_invalid'): void {
  clearTokens();
  clearUserSession();
  clearRegularExamStartRecords();
  if (typeof window === 'undefined') return;
  const params = reason ? new URLSearchParams({ reason }) : undefined;
  window.location.replace(getLoginPathname(params));
}
